/**
 * Ceci est la page index qui comporte les pagination dans le menu Arrivées et Departs
 *
 * Tous les styles sont en Tailwindcss et components avec Headless UI
 */
import React, { memo, useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { useReduxSelector } from "@hooks/useReduxSelector";
import { useEligibleEvaluatorData } from "@hooks/useEligibleEvaluatorData";
import "@routes/IconeSvg";
import {
  protocolActions,
  employeFlowActions,
  employeTaskActions,
  typeDemissionActions
} from "@store/actions";

import BigDisclosure from "@components/disclosure/BigDisclosure";

// import OnBoardingBigClosure from "@components/disclosure/OnBoardingBigClosure";
import EmployerFlow from "./EmployerFlow";
import IntegrationProtocole from "./IntegrationProtocole";

// import ToCompleteTasks from "./ToCompleteTasks";

const BeginEnd = ({ showList, toggleLoadProtocol, avalaibleSections }) => {
  const protocol = useReduxSelector(({ onboarding }) => onboarding.protocol);
  const employeFlow = useReduxSelector(
    ({ onboarding }) => onboarding.employeFlow
  );
  const employeTask = useReduxSelector(
    ({ onboarding }) => onboarding.employeTask
  );
  const typeDemission = useReduxSelector(
    ({ onboarding: { typeDemission } }) => typeDemission
  );
  const { t } = useTranslation("beginEnd.departure");
  const [superZIndexFlow, setSuperZIndexFlow] = useState("");
  // const [superZIndexTask, setSuperZIndexTask] = useState("");
  const reduxDispatch = useDispatch();
  useEligibleEvaluatorData();

  useEffect(() => {
    if (!protocol?.isLoaded) reduxDispatch(protocolActions.loadData);
    if (!typeDemission?.isLoaded) reduxDispatch(typeDemissionActions.loadData);
  }, []);

  useEffect(() => {
    if (!employeFlow?.isLoaded) {
      reduxDispatch(employeFlowActions.loadData);
    } else if (employeFlow.isDataOutdated) {
      reduxDispatch(employeFlowActions.refreshData);
    }
  }, [
    employeFlow?.isDataOutdated,
    employeFlow?.isLoaded,
    reduxDispatch
  ]);

  useEffect(() => {
    if (!employeTask?.isLoaded) {
      reduxDispatch(employeTaskActions.loadData);
    } else if (employeTask.isDataOutdated) {
      reduxDispatch(employeTaskActions.refreshData);
    }
  }, [
    employeTask?.isDataOutdated,
    employeTask?.isLoaded,
    reduxDispatch
  ]);

  return (
    <div className="arh-flex arh-flex-col arh-space-y-2">
      {avalaibleSections?.some(
        (item) => item === "beginEndSectionEmployeeFlow"
      ) ? (
        <BigDisclosure
          title={t("Flux d’employés")}
          defaultOpen={showList}
          notIcone={true}
          spaceTitle={true}
          classSpaceTitle="arh-ml-0"
          classParent={superZIndexFlow}
          paddingRight="arh-px-9"
        >
          <EmployerFlow
            toggleLoadProtocol={toggleLoadProtocol}
            setSuperZIndex={setSuperZIndexFlow}
          />
        </BigDisclosure>
      ) : (
        ""
      )}
      {/* <OnBoardingBigClosure
        title={t("Tâches à réaliser et terminées")}
        spaceTitle={true}
        classSpaceTitle="arh-ml-4"
         notIcone={true}
        classParent={superZIndexTask}
      >
        <ToCompleteTasks setSuperZIndex={setSuperZIndexTask} />
      </OnBoardingBigClosure> */}
      {avalaibleSections?.some(
        (item) => item === "beginEndSectionIntegrationAndDepartureProtocol"
      ) ? (
        <BigDisclosure
          title={t("Protocoles d’intégration et de départ")}
          spaceTitle={true}
          classSpaceTitle="arh-ml-0"
          notIcone={true}
          classParent="draggable_content"
          paddingRight="arh-px-9"
        >
          <IntegrationProtocole />
        </BigDisclosure>
      ) : (
        ""
      )}
    </div>
  );
};

export default memo(BeginEnd);
